import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Navbar from "./components/nav/navbar";
import PortalHome from "./pages/PortalHome";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignUpPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import SubmissionsPage from "./pages/SubmissionsPage";
import AboutPage from "./pages/AboutPage";
import RetailersPage from "./pages/RetailersPage";
import TrustAndSafetyPage from "./pages/legal/TrustAndSafetyPage";
import TermsOfUsePage from "./pages/legal/TermsOfUsePage";
import PrivacyPolicyPage from "./pages/legal/PrivacyPolicyPage";
import RefundPolicyPage from "./pages/legal/RefundPolicyPage";
import AccessibilityPage from "./pages/legal/AccessibilityPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/portal" element={<PortalHome />} />
          <Route path="/" element={<PortalHome />} />
          <Route path="/portal/login" element={<LoginPage />} />
          <Route path="/portal/signup" element={<SignupPage />} />
          <Route path="/portal/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/portal/submissions" element={<SubmissionsPage />} />
          <Route path="/portal/about" element={<AboutPage />} />
          <Route path="/portal/retailers" element={<RetailersPage />} />
          {/* Platform legal pages. Root-level on purpose: the shared footer
              (src/shared/Footer.js) links here from every app, and these paths
              fall through firebase.json's catch-all to the Portal. */}
          <Route path="/trust-and-safety" element={<TrustAndSafetyPage />} />
          <Route path="/terms-of-use" element={<TermsOfUsePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route path="/accessibility-statement" element={<AccessibilityPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;